module.exports = __webpack_public_path__ + "img/icon-English.39bb0e83.png";